import { useAccount } from 'components/account/AccountProvider';
import { dayToInputValue } from 'libs/util/dateOnly';
import { useEffect, useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { FormSaleItemGroup } from 'components/catalog/form/FormSaleItemGroup';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { FormPanel } from 'components/form/FormPanel';
import { FormPanels } from 'components/form/FormPanels';
import { FormSection } from 'components/form/FormSection';
import { FormSelect } from 'components/form/FormSelect';
import { FormSwitch } from 'components/form/FormSwitch';
import { FormToggle } from 'components/form/FormToggle';
import { FormDate } from 'components/form/FormDate';
import { TranslatableFormInput } from 'components/form/TranslatableFormInput';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { FormMultiSelect } from 'components/form/FormMultiSelect';
import { TaxesQuery } from 'graphql/Tax/queries/TaxesQuery';
import { TranslatableRichTextInput } from 'components/form/TranslatableRichTextInput';
import { useModal } from 'components/modal/ModalStack';
import { Confirm } from 'components/confirm/Confirm';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { useUser } from 'components/user/UserProvider';
import { isOptionAndManufacturing } from 'helpers/optionConfiguration';
import './SaleItemForm.scss';
import { Requires } from 'components/user/Requires';
import { SaleItemAvailabilitySection } from 'modules/catalog/saleItem/components/SaleItemAvailabilitySection';
import { SaleItemConfigurationField } from 'modules/catalog/saleItem/components/SaleItemConfigurationField';
import { ClientOptionsQuery } from 'graphql/Client/queries/ClientOptionsQuery';
/**
 * @component SaleItemForm
 * @since 1.0.0
 */
export function SaleItemForm(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const { data, option, manufacturing } = Object.assign({ option: false }, props);
    const account = useAccount();
    const modal = useModal();
    const user = useUser();
    const [dataTax] = useQuery(TaxesQuery);
    const canAssignPartners = user.can('saleItem.partnerExclusivity') && user.can('partner.manage');
    const [partnersData] = useQuery(ClientOptionsQuery, {
        variables: {
            input: {
                isEndClient: false,
                limit: 500
            }
        },
        skip: !canAssignPartners
    });
    const partnerOptions = (_c = (_b = (_a = partnersData === null || partnersData === void 0 ? void 0 : partnersData.clients) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map((partner) => ({
        label: partner.name,
        value: partner.id
    }))) !== null && _c !== void 0 ? _c : [];
    const entity = option
        ? 'SALE_ITEM_OPTION'
        : manufacturing
            ? 'SALE_ITEM_MANUFACTURING'
            : 'SALE_ITEM';
    const [configuration, setConfiguration] = useState('');
    const [groupsOptions, setGroupsOptions] = useState((data === null || data === void 0 ? void 0 : data.groups) ? data === null || data === void 0 ? void 0 : data.groups.map((group) => group.id) : []);
    const [partnerIds, setPartnerIds] = useState((_e = (_d = data === null || data === void 0 ? void 0 : data.partners) === null || _d === void 0 ? void 0 : _d.map((partner) => partner.id)) !== null && _e !== void 0 ? _e : []);
    const [isActiveTax, setIsActiveTax] = useState((_f = data === null || data === void 0 ? void 0 : data.taxable) !== null && _f !== void 0 ? _f : true);
    const [price, setPrice] = useState((_h = (_g = data === null || data === void 0 ? void 0 : data.price) === null || _g === void 0 ? void 0 : _g.toString()) !== null && _h !== void 0 ? _h : '0');
    const [voucherEligibleValue, setVoucherEligibleValue] = useState((data === null || data === void 0 ? void 0 : data.voucherEligible) ? '1' : '0');
    const [requiresPlannedDateValue, setRequiresPlannedDateValue] = useState((data === null || data === void 0 ? void 0 : data.requiresPlannedDate) ? '1' : '0');
    const [voucherHasValidity, setVoucherHasValidity] = useState((data === null || data === void 0 ? void 0 : data.voucherValidityType) ? '1' : '0');
    const [voucherValidityTypeValue, setVoucherValidityTypeValue] = useState((_j = data === null || data === void 0 ? void 0 : data.voucherValidityType) !== null && _j !== void 0 ? _j : 'PERIOD');
    const [quantityCalculationValue, setQuantityCalculationValue] = useState((_k = data === null || data === void 0 ? void 0 : data.quantityCalculation) !== null && _k !== void 0 ? _k : 'STANDARD');
    const [alsoManufacturing, setAlsoManufacturing] = useState(isOptionAndManufacturing(data === null || data === void 0 ? void 0 : data.optionConfiguration));
    const [trackQuantityActive, setTrackQuantityActive] = useState((data === null || data === void 0 ? void 0 : data.trackQuantity) !== false);
    const [trackInventoryValue, setTrackInventoryValue] = useState((data === null || data === void 0 ? void 0 : data.trackInventory) ? '1' : '0');
    const hasDirectSales = account.configs
        ? getConfigurationFieldValue(account.configs, 'HAS_DIRECT_SALES')
        : null;
    const formConfigurationOptions = FormConfigurationOptions.filter((option) => option.value === 'SIMPLE' ||
        (option.value === 'FINISHED' && hasDirectSales !== 'FALSE') ||
        (option.value === 'CONFIGURABLE' && user.can('saleItemVariant.manage')));
    useEffect(() => {
        var _a, _b, _c;
        setConfiguration((_a = data === null || data === void 0 ? void 0 : data.configuration) !== null && _a !== void 0 ? _a : 'SIMPLE');
        setGroupsOptions(data && data.groups ? data === null || data === void 0 ? void 0 : data.groups.map((group) => group.id) : []);
        setPartnerIds((_c = (_b = data === null || data === void 0 ? void 0 : data.partners) === null || _b === void 0 ? void 0 : _b.map((partner) => partner.id)) !== null && _c !== void 0 ? _c : []);
    }, [data]);
    /**
     * @function onConfigurationChange
     * @since 1.0.0
     * @hidden
     */
    function onConfigurationChange(value) {
        setConfiguration(value);
    }
    /**
     * @function onGroupsChange
     * @since 1.0.0
     * @hidden
     */
    const onGroupsChange = (ids) => {
        setGroupsOptions(ids);
    };
    const onPartnersChange = (ids) => {
        setPartnerIds(ids);
    };
    /**
     * @function onPriceChange
     * @since 1.0.0
     * @hidden
     */
    const onPriceChange = (value) => {
        setPrice(value);
    };
    /**
     * @function onPriceChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onPriceChangeOnBlur = () => {
        var _a;
        if (option && data && price !== ((_a = data === null || data === void 0 ? void 0 : data.price) === null || _a === void 0 ? void 0 : _a.toString())) {
            modal.present({
                style: 'dialog',
                title: t('Price Update'),
                picto: 'times',
                modal: (React.createElement(Confirm, { title: t('Apply price update to mapped products?'), infos: t('Do you want to update the price of this option in all products where it is mapped?'), acceptText: t('Yes'), refuseText: t('No'), onAccept: () => {
                        modal.dismiss();
                        if (props.onApplyPriceUpdate) {
                            props.onApplyPriceUpdate(true);
                        }
                    }, onRefuse: () => {
                        modal.dismiss();
                    } }))
            });
        }
        if (props.onApplyPriceUpdate) {
            props.onApplyPriceUpdate(false);
        }
    };
    const options = (_l = dataTax === null || dataTax === void 0 ? void 0 : dataTax.taxes.filter((tax) => !tax.default).map((group) => ({
        value: group.id,
        label: group.title
    }))) !== null && _l !== void 0 ? _l : [];
    const onChange = () => {
        setIsActiveTax(!isActiveTax);
    };
    const showConfiguration = !manufacturing && !option;
    const showStoreSale = !manufacturing && !option && configuration === 'FINISHED';
    const configurationChanged = !!data && configuration !== '' && configuration !== data.configuration;
    return (React.createElement(Fragment, null,
        React.createElement(FormPanels, null,
            React.createElement(FormPanel, null,
                showConfiguration && (React.createElement(SaleItemConfigurationField, { value: configuration, options: formConfigurationOptions, onChange: onConfigurationChange, notice: configurationChanged
                        ? t('Save to show the tabs for this product type.')
                        : null })),
                React.createElement("div", { className: "sale-item-form-container" },
                    React.createElement("div", null,
                        React.createElement(FormSection, { className: "sale-item-form-section", title: t('Identification') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(TranslatableFormInput, { type: "text", name: "title", path: "translations", label: t('Name'), values: data === null || data === void 0 ? void 0 : data.translations, languages: account.languages, placeholder: t('Enter Name'), required: true }))),
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormInput, { type: "text", name: "sku", label: t('SKU'), value: data === null || data === void 0 ? void 0 : data.sku, placeholder: t('Enter SKU'), required: true })),
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSaleItemGroup, { name: "groups", label: t('Category'), value: groupsOptions, onChange: onGroupsChange, entity: entity })))),
                        React.createElement(FormSection, { className: "sale-item-form-section", title: manufacturing ? t('Price') : t('Price and taxes') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormInput, { type: "number", name: "price", label: t('Price'), value: (_m = data === null || data === void 0 ? void 0 : data.price) === null || _m === void 0 ? void 0 : _m.toString(), onChange: (value) => {
                                            onPriceChange(value);
                                        }, onBlur: onPriceChangeOnBlur, required: !manufacturing, placeholder: '0.00', suffix: "$ CAD" })),
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormInput, { type: "number", name: "cost", label: t('Cost Price'), value: (_o = data === null || data === void 0 ? void 0 : data.cost) === null || _o === void 0 ? void 0 : _o.toString(), placeholder: '0.00', suffix: "$ CAD" }))),
                            !manufacturing && (React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSelect, { placeholder: "", name: "unitOfMeasurement", label: t('Unit of Measurement'), value: (_p = data === null || data === void 0 ? void 0 : data.unitOfMeasurement) !== null && _p !== void 0 ? _p : 'EA', options: FormSaleItemUnitOfMeasurement })),
                                option && (React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormToggle, { name: "quantityCalculation", label: t('Multiply by planned days'), infos: t('When enabled, the entered quantity is multiplied by the number of days from the planned date to calculate the line total.'), value: quantityCalculationValue, options: [
                                            { label: t('No'), value: 'STANDARD' },
                                            { label: t('Yes'), value: 'PER_UNIT_PER_DAY' }
                                        ], onChange: setQuantityCalculationValue }))))),
                            !manufacturing && (React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSwitch, { name: "taxable", label: t('Taxable'), active: isActiveTax, onChange: onChange, required: true })),
                                isActiveTax && options.length > 0 && (React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormMultiSelect, { name: "taxes", label: t('Additional taxes'), tooltip: t('Default taxes will be applied automatically'), options: options, value: data === null || data === void 0 ? void 0 : data.taxes.map((tax) => tax.id) })))))),
                        option && (React.createElement(FormSection, { className: "sale-item-form-section", title: t('Task') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSwitch, { name: "alsoManufacturing", label: t('Also a task or action'), infos: t('When enabled, this option also appears in task lists and is added as a manufacturing task when the deal is confirmed.'), active: alsoManufacturing, onChange: setAlsoManufacturing, required: true })),
                                alsoManufacturing && (React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSwitch, { name: "trackQuantity", label: t('Track quantity'), infos: t('When disabled, this task is created with a fixed quantity (BOM quantity, or 1 for an option) and the quantity field is hidden in task lists and PDFs.'), active: trackQuantityActive, onChange: setTrackQuantityActive, required: true })))))),
                        manufacturing && (React.createElement(FormSection, { className: "sale-item-form-section", title: t('Task') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormToggle, { name: "visibility", label: t('Visibility'), infos: t('Internal tasks are hidden from client-facing PDFs and approval pages unless included.'), value: (data === null || data === void 0 ? void 0 : data.visibility) === 'INTERNAL'
                                            ? 'INTERNAL'
                                            : 'GLOBAL', options: [
                                            { value: 'GLOBAL', label: t('External') },
                                            { value: 'INTERNAL', label: t('Internal') }
                                        ] })),
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSwitch, { name: "trackQuantity", label: t('Track quantity'), infos: t('When disabled, the quantity field is hidden in task lists and PDFs.'), active: trackQuantityActive, onChange: setTrackQuantityActive, required: true }))))),
                        !manufacturing && (React.createElement(FormSection, { className: "sale-item-form-section", title: t('Distribution') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSelect, { placeholder: "", name: "visibility", label: t('Visibility'), value: (_q = data === null || data === void 0 ? void 0 : data.visibility) !== null && _q !== void 0 ? _q : 'GLOBAL', options: [
                                            {
                                                value: 'GLOBAL',
                                                label: t('Global')
                                            },
                                            {
                                                value: 'INTERNAL',
                                                label: t('Internal')
                                            },
                                            {
                                                value: 'PUBLIC',
                                                label: t('Public')
                                            }
                                        ] }))),
                            canAssignPartners && (React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(FormMultiSelect, { name: "partners", label: t('Partners'), infos: t('Leave empty to make this product available to everyone. Select partners to restrict it to them.'), options: partnerOptions, value: partnerIds, onChange: onPartnersChange, optional: true })))))),
                        showStoreSale && (React.createElement(FormSection, { className: "sale-item-form-section", title: t('Store sale') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormInput, { type: "number", name: "order", label: t('Display order in store'), infos: t('Lower numbers appear first in the store.'), value: (_r = data === null || data === void 0 ? void 0 : data.order) === null || _r === void 0 ? void 0 : _r.toString(), placeholder: "0", step: "1", optional: true }))),
                            hasDirectSales !== 'FALSE' && (React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(FormToggle, { name: "requiresPlannedDate", label: t('Linked to a date?'), infos: t('If enabled, the customer will be asked for a desired date during purchase.'), value: requiresPlannedDateValue, options: [
                                            { label: t('No'), value: '0' },
                                            { label: t('Yes'), value: '1' }
                                        ], onChange: setRequiresPlannedDateValue })))),
                            user.can('voucher.manage') && (React.createElement(React.Fragment, null,
                                React.createElement(FormGroup, null,
                                    React.createElement(FormField, null,
                                        React.createElement(FormToggle, { name: "voucherEligible", label: t('Linked to a voucher?'), infos: t('If enabled, the sale will generate a voucher. The information to collect for each voucher is set in the « Information per voucher » tab.'), value: voucherEligibleValue, options: [
                                                { label: t('No'), value: '0' },
                                                { label: t('Yes'), value: '1' }
                                            ], onChange: setVoucherEligibleValue })),
                                    voucherEligibleValue === '1' && (React.createElement(FormField, null,
                                        React.createElement(FormToggle, { name: "voucherHasValidity", label: t('Validity period'), infos: t('If enabled, the voucher will have a validity period.'), value: voucherHasValidity, options: [
                                                { label: t('No'), value: '0' },
                                                { label: t('Yes'), value: '1' }
                                            ], onChange: setVoucherHasValidity })))),
                                voucherEligibleValue === '1' &&
                                    voucherHasValidity === '1' && (React.createElement(FormGroup, null,
                                    React.createElement(FormField, null,
                                        React.createElement(FormSelect, { name: "voucherValidityType", label: t('Type'), value: voucherValidityTypeValue, placeholder: "", options: [
                                                {
                                                    value: 'PERIOD',
                                                    label: t('Period (days)')
                                                },
                                                { value: 'FIXED', label: t('Fixed date') }
                                            ], onChange: setVoucherValidityTypeValue })),
                                    voucherValidityTypeValue === 'PERIOD' && (React.createElement(FormField, null,
                                        React.createElement(FormInput, { type: "number", name: "voucherValidityDays", label: t('Number of days'), value: (_t = (_s = data === null || data === void 0 ? void 0 : data.voucherValidityDays) === null || _s === void 0 ? void 0 : _s.toString()) !== null && _t !== void 0 ? _t : '', placeholder: t('Enter number of days') }))),
                                    voucherValidityTypeValue === 'FIXED' && (React.createElement(FormField, null,
                                        React.createElement(FormDate, { name: "voucherValidityDate", label: t('Expiry date'), value: dayToInputValue(data === null || data === void 0 ? void 0 : data.voucherValidityDate), time: false, onChange: () => { } }))))))))),
                        !manufacturing && (React.createElement(FormSection, { className: "sale-item-form-section", title: t('Calendar and availability') },
                            React.createElement(Requires, { permission: ['calendar.manage'] },
                                React.createElement(FormGroup, null,
                                    React.createElement(FormField, { ratio: 6 },
                                        React.createElement(FormSwitch, { name: "showInCalendar", label: t('Show in calendar'), active: (_u = data === null || data === void 0 ? void 0 : data.showInCalendar) !== null && _u !== void 0 ? _u : false, required: true })))),
                            React.createElement(SaleItemAvailabilitySection, { data: data }))),
                        !manufacturing && user.can('inventory.manage') && (React.createElement(FormSection, { className: "sale-item-form-section", title: t('Inventory') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormToggle, { name: "trackInventory", label: t('Track inventory'), value: trackInventoryValue, options: [
                                            { label: t('No'), value: '0' },
                                            { label: t('Yes'), value: '1' }
                                        ], onChange: setTrackInventoryValue })),
                                trackInventoryValue === '1' && (React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormSelect, { name: "outOfStockPolicy", label: t('When out of stock'), value: (_v = data === null || data === void 0 ? void 0 : data.outOfStockPolicy) !== null && _v !== void 0 ? _v : 'BLOCK', placeholder: "", options: [
                                            { value: 'BLOCK', label: t('Block the sale') },
                                            {
                                                value: 'BACKORDER',
                                                label: t('Allow pre-orders')
                                            }
                                        ] })))),
                            trackInventoryValue === '1' &&
                                !data &&
                                configuration !== 'CONFIGURABLE' && (React.createElement(FormGroup, null,
                                React.createElement(FormField, { ratio: 6 },
                                    React.createElement(FormInput, { type: "number", name: "inventory", label: t('Initial stock'), placeholder: "0", optional: true }))))))),
                    React.createElement("div", { className: "sale-item-form-content" },
                        React.createElement(FormSection, { className: "sale-item-form-section", title: t('Description') },
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(TranslatableRichTextInput, { name: "summary", path: "translations", label: t('Short Description'), optional: true, values: data === null || data === void 0 ? void 0 : data.translations, languages: account.languages }))),
                            React.createElement(FormGroup, null,
                                React.createElement(FormField, null,
                                    React.createElement(TranslatableRichTextInput, { name: "infos", path: "translations", label: t('Long Description'), optional: true, values: data === null || data === void 0 ? void 0 : data.translations, languages: account.languages, placeholder: t('Enter Long Description') }))))))))));
}
/**
 * @const FormConfigurationOptions
 * @since 1.0.0
 */
export const FormConfigurationOptions = [
    {
        value: 'SIMPLE',
        label: t('Standard Product'),
        infos: t('Sold in deals and quotes.')
    },
    {
        value: 'FINISHED',
        label: t('Finished Product'),
        infos: t('Also sold in the store: adds store settings, vouchers, bonuses and promotions.')
    },
    {
        value: 'CONFIGURABLE',
        label: t('Configurable Product'),
        infos: t('Sold through variants built from attributes.')
    }
];
/**
 * @function getUnitOfMeasurementLabel
 * @since 1.0.0
 * @hidden
 */
export function getUnitOfMeasurementLabel(value) {
    const unit = FormSaleItemUnitOfMeasurement.find((item) => item.value === value);
    return unit && value !== 'EA' ? unit.label : '';
}
/**
 * @const FormSaleItemUnitOfMeasurement
 * @since 1.0.0
 */
export const FormSaleItemUnitOfMeasurement = [
    // Quantity
    { value: 'EA', label: t('Unit') },
    // Length
    { value: 'MTR', label: t('m') },
    { value: 'CM', label: t('cm') },
    { value: 'MM', label: t('mm') },
    { value: 'KM', label: t('km') },
    { value: 'IN', label: t('in') },
    { value: 'FT', label: t('ft') },
    { value: 'YD', label: t('yd') },
    // Weight
    { value: 'KG', label: t('kg') },
    { value: 'GRM', label: t('g') },
    { value: 'LB', label: t('lb') },
    { value: 'OZ', label: t('oz') },
    // Volume
    { value: 'LTR', label: t('L') },
    { value: 'ML', label: t('mL') },
    { value: 'M3', label: t('m³') },
    // Surface
    { value: 'M2', label: t('m²') },
    { value: 'CM2', label: t('cm²') },
    { value: 'SQF', label: t('ft²') },
    { value: 'SQI', label: t('in²') },
    // Time
    { value: 'MIN', label: t('min') },
    { value: 'HUR', label: t('h') },
    { value: 'DAY', label: t('d') },
    { value: 'WEE', label: t('w') },
    { value: 'MON', label: t('mo') },
    { value: 'YEA', label: t('y') }
];
